import React, { useState, useEffect } from 'react';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import { Icon } from 'legacy-packages/ft-cb';
import {
  extractS3ResourceDomainFromUrl,
  getSignedUnitResource,
  isS3Resource,
} from 'legacy-src/utility/utils';
import ResourceTypes from 'legacy-packages/unit-outline/src/constants';
import { Link } from 'react-router';

const ResourceLink = ({ resource, useClassroomResourceAddress, subjectId }) => {
  const [signedResourceURL, setSignedResourceURL] = useState(resource.url);
  const anchorPageSplit = resource.url.split('#page=');
  const resourceUrl = anchorPageSplit[0];

  useEffect(() => {
    const getAnchoredUrl = (url) => {
      let appendUrl = '';
      if (anchorPageSplit.length > 1) {
        appendUrl = `#page=${anchorPageSplit[1]}`;
      }
      return `${url}${appendUrl}`;
    };

    if (!useClassroomResourceAddress) {
      const getSignedUrl = async (url) => {
        const signedUrl = await getSignedUnitResource(url);
        const anchoredUrl = getAnchoredUrl(signedUrl);
        setSignedResourceURL(anchoredUrl);
      };
      if (resource.__typename === ResourceTypes.URL) {
        getSignedUrl(resourceUrl);
      }
    } else if (
      resource.__typename === ResourceTypes.URL &&
      isS3Resource(resourceUrl)
    ) {
      setSignedResourceURL(
        `${FYM_FRONTEND_URL}/${subjectId}/resources/${getAnchoredUrl(extractS3ResourceDomainFromUrl(resourceUrl))}`,
      );
    }
  }, []);

  return (
    <Link
      to={{
        pathname: signedResourceURL,
      }}
      target="_blank"
      className="lesson"
    >
      {resource.displayName}
      {resource.__typename === ResourceTypes.PARTNER_LINK ? (
        <Icon name="arrow-north-west" size="1.8rem" />
      ) : null}
    </Link>
  );
};

const DisplayLessons = ({
  subjectId,
  lessons,
  label,
  useClassroomResourceAddress,
}) => (
  <PopOver
    isNarrow
    className="lessons-divider"
    trigger={
      <div className="lessons">
        <Icon name="arrow-east" />
        {label}
      </div>
    }
    key={`${label}-lessons-list-popover`}
  >
    <div className="lessons-list" key={`${label}-lessons-list`}>
      {lessons.map((lesson) => (
        <ResourceLink
          key={lesson.displayName}
          resource={lesson}
          subjectId={subjectId}
          useClassroomResourceAddress={useClassroomResourceAddress}
        />
      ))}
    </div>
  </PopOver>
);

export default DisplayLessons;
